import optimizedFaviconB2bUrl from 'url:../assets/favicon-b2b.png?as=webp&width=51';
import optimizedFaviconB2cUrl from 'url:../assets/favicon-b2c.png?as=webp&width=51';
import optimizedLogoB2bUrl from 'url:../assets/logo-b2b.png?as=webp&width=150';
import optimizedLogoB2cUrl from 'url:../assets/logo-b2c.png?as=webp&width=150';

export class FooterComponent extends HTMLElement {
    static observedAttributes = ['theme'];

    constructor() {
        super();
    }

    connectedCallback() {
        const theme = this.getAttribute('theme');
        const strokeColor = theme === 'b2b' ? '#4F6F52' : '#00948D';

        const faviconUrl = theme === 'b2b' ? optimizedFaviconB2bUrl : optimizedFaviconB2cUrl;
        const logoUrl = theme === 'b2b' ? optimizedLogoB2bUrl : optimizedLogoB2cUrl;

        this.innerHTML = `
        <footer class="section-footer">
            <a href="/" class="logo__wrapper" aria-label="logo">
                <img class="icon" src="${faviconUrl}" alt="Ikona logo" width="51" height="51"
                     loading="lazy">
                <img class="logo" src="${logoUrl}" alt="logo" width="150" height="35"
                     loading="lazy">
            </a>
        
            <div class="footer-actions">
                <div class="footer-actions__action" x-data
                     @click="window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })">
                    <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.99992 14.6668C11.6819 14.6668 14.6666 11.6822 14.6666 8.00016C14.6666 4.31816 11.6819 1.3335 7.99992 1.3335C4.31792 1.3335 1.33325 4.31816 1.33325 8.00016C1.33325 11.6822 4.31792 14.6668 7.99992 14.6668Z"
                              stroke="${strokeColor}" stroke-width="2"/>
                        <path d="M7.99992 14.6668C11.6819 14.6668 14.6666 11.6822 14.6666 8.00016C14.6666 4.31816 11.6819 1.3335 7.99992 1.3335C4.31792 1.3335 1.33325 4.31816 1.33325 8.00016C1.33325 11.6822 4.31792 14.6668 7.99992 14.6668Z"
                              stroke="${strokeColor}" stroke-width="2" stroke-linejoin="round"/>
                        <path d="M11 9L8 6L5 9" stroke="${strokeColor}" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round"/>
                    </svg>
                    <span>Wróć na górę</span>
                </div>
                <a class="footer-actions__action" href="https://www.facebook.com/brotec.domydrewniane" aria-label="facebook">
                    <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16 8C16 3.58175 12.4183 0 8 0C3.58175 0 0 3.58175 0 8C0 11.993 2.9255 15.3027 6.75 15.9028V10.3125H4.71875V8H6.75V6.2375C6.75 4.2325 7.94438 3.125 9.77175 3.125C10.647 3.125 11.5625 3.28125 11.5625 3.28125V5.25H10.5538C9.55994 5.25 9.25 5.86669 9.25 6.49937V8H11.4688L11.1141 10.3125H9.25V15.9028C13.0745 15.3027 16 11.9931 16 8Z"
                              fill="#1877F2"/>
                        <path d="M11.1141 10.3125L11.4688 8H9.25V6.49937C9.25 5.86662 9.55994 5.25 10.5538 5.25H11.5625V3.28125C11.5625 3.28125 10.647 3.125 9.77169 3.125C7.94438 3.125 6.75 4.2325 6.75 6.2375V8H4.71875V10.3125H6.75V15.9028C7.16351 15.9676 7.58144 16.0001 8 16C8.41856 16.0001 8.83649 15.9676 9.25 15.9028V10.3125H11.1141Z"
                              fill="white"/>
                    </svg>
                    <div class="action-underlined fb">
                        <span>Odwiedź nas na Facebooku</span>
                        <div class="underline fb"></div>
                    </div>
                </a>
                <a class="footer-actions__action" href="/blog" aria-label="Blog">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M3 19a9 9 0 0 1 9 0a9 9 0 0 1 9 0M3 6a9 9 0 0 1 9 0a9 9 0 0 1 9 0M3 6v13m9-13v13m9-13v13"/>
                    </svg>
                    <div class="action-underlined">
                        <span>Zajrzyj na naszego bloga</span>
                        <div class="underline"></div>
                    </div>
                </a>
            </div>

            <address class="footer-company">
                <span class="footer-company__line">
                    ul. Ustronie 51a, 87-300 Brodnica
                    <span class="footer-company__sep">·</span>
                    <a href="tel:+48566498532">+48 566 498 532</a>
                </span>
                <span class="footer-company__line">
                    <a href="mailto:kontakt@brotec.pl">kontakt@brotec.pl</a>
                    <span class="footer-company__sep">·</span>
                    NIP 874 179 85 09
                </span>
            </address>
        </footer>
        `;
    }
}

customElements.define('bc-footer', FooterComponent);